import React, { useState } from 'react';

import { Dialog, DialogProps } from 'primereact/dialog';
import { Button, ButtonsGroup } from 'components/commons';

import tel from 'assets/svg/tel.svg';
import email from 'assets/svg/e-mail.svg';
import wpp from 'assets/svg/whatsapp.svg';

type ContactUsDialogProps = {
    label: string;
};

const ContactUsDialog: React.FC<ContactUsDialogProps> = ({ label }) => {
    const [opened, setOpened] = useState(false);

    const footer = (
        <ButtonsGroup className="w-auto">
            <Button
                label="fechar"
                variant="secondary"
                onClick={() => setOpened(false)}
            />
        </ButtonsGroup>
    );

    const dialogProps: DialogProps = {
        header: 'Fale Conosco',
        footer,
        visible: opened,
        modal: true,
        closable: false,
        onHide: () => setOpened(false),
        style: {
            width: '40vw',
            minWidth: '292px',
            maxWidth: '470px'
        },
        contentStyle: {
            maxHeight: '70vh',
            overflowY: 'auto',
            overflowX: 'hidden'
        },
    };

    return (
        <>
            <a onClick={() => setOpened(true)}>{ label }</a>

            <Dialog {...dialogProps}>
                <div className='help-modal'>
                    <div className='hp-title'>Precisa de ajuda?</div>

                    <div className='hp-text'>Ligue agora e tire suas dúvidas<br/>com um de nossos<br/>consultores.</div>

                    <div className='hp-item'>
                        <img src={tel} role='presentation'/>

                        <a href='tel:36093737' className='hp-phone'>3609-3737</a>

                        <div>Capitais e regiões metropolitanas</div>
                    </div>

                    <div className='hp-item'>
                        <img src={tel} role='presentation'/>

                        <a href='tel:552136093737' className='hp-phone'>(21) 3609-3737</a>

                        <div>Demais localidades</div>
                    </div>

                    <div className='hp-item'>
                        <img src={wpp} role='presentation'/>

                        <a href='https://api.whatsapp.com/send?phone=551153300448' target='_blank' rel='noreferrer noopener' className='hp-phone'>
                            (11) 5330-0448
                        </a>
                    </div>

                    <div className='hp-item'>
                        <img src={email} role='presentation'/>

                        <a href='mailto:faleconosco@bizcap.com.br' target='_blank' rel='noreferrer noopener' className='hp-mail'>
                            faleconosco@bizcap.com.br
                        </a>
                    </div>
                </div>
            </Dialog>
        </>
    );
};

export default ContactUsDialog;
